<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="6">
							<a-form-item label="用户">
								<a-input v-model="queryParams.userKeyword" placeholder="ID/账号/昵称" allow-clear />
							</a-form-item>
						</a-col>
						<a-col :span="6">
							<span class="x-filter-submit-box">
								<a-button type="primary" @click="onSearch">查询</a-button>
								<a-button style="margin-left: 8px" @click="onReset">重置</a-button>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button v-has="'/member/userRechargeAdd'" type="primary" icon="plus" @click="openRecharge">充值</a-button>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<span slot="user" slot-scope="record">
					<div>{{ record.userLoginAccount || ('ID:' + record.userId) }}</div>
					<div class="user-sub">{{ record.userNickname || '-' }}</div>
				</span>
				<span slot="operator" slot-scope="record">
					{{ record.operatorName || '-' }}
				</span>

				<template slot="amount" slot-scope="record">
					<span :class="record.amount >= 0 ? 'amount-up' : 'amount-down'">{{ record.amount }}</span>
				</template>

			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					@change="pageChange"
					:hideOnSinglePage="true"
					show-less-items
				/>
			</div>

			<user-recharge-form
				:visible="rechargeFormVisible"
				:loading="rechargeFormLoading"
				@cancel="rechargeFormCancel"
				@ok="rechargeFormOk"
			/>
		</a-card>
	</div>
</template>

<script>
import UserRechargeForm from './UserRechargeForm';
import { userRechargeList, userRechargeAdd } from '@/api/member/recharge';

const tableColumns = [
	{ title: '#', dataIndex: 'id', width: 80 },
	{ title: '用户', scopedSlots: { customRender: 'user' }, width: 200 },
	{ title: '充值金额', scopedSlots: { customRender: 'amount' }, width: 120 },
	{ title: '操作人', scopedSlots: { customRender: 'operator' }, width: 160 },
	{ title: '时间', dataIndex: 'created', width: 180 },
];

export default {
	components: {
		UserRechargeForm,
	},
	data() {
		return {
			queryParams: {},
			tableLoading: false,
			tableColumns,
			tableData: [],
			totalRow: 0,
			pageSize: 20,
			pageIndex: 1,
			rechargeFormVisible: false,
			rechargeFormLoading: false,
		};
	},
	created() {
		this.fetchTableData();
	},
	methods: {
		fetchTableData() {
			this.tableLoading = true;
			const params = {
				...this.queryParams,
				pageSize: this.pageSize,
				page: this.pageIndex,
			};
			return userRechargeList(params).then((res) => {
				this.tableData = res.data.recordList || [];
				this.totalRow = res.data.totalRow || 0;
			}).finally(() => {
				this.tableLoading = false;
			});
		},
		onSearch() {
			this.pageIndex = 1;
			this.fetchTableData();
		},
		onReset() {
			this.queryParams = {};
			this.pageIndex = 1;
			this.fetchTableData();
		},
		pageChange(current) {
			this.pageIndex = current;
			this.fetchTableData();
		},
		openRecharge() {
			this.rechargeFormVisible = true;
		},
		rechargeFormCancel() {
			this.rechargeFormVisible = false;
		},
		rechargeFormOk(formData) {
			this.rechargeFormLoading = true;
			userRechargeAdd(formData).then((res) => {
				if (!res.isSucceed) {
					this.$message.error(res.message || '充值失败');
					return;
				}
				this.rechargeFormVisible = false;
				this.fetchTableData();
				this.$message.success('充值成功');
			}).finally(() => {
				this.rechargeFormLoading = false;
			});
		},
	},
};
</script>

<style scoped>
.user-sub {
	font-size: 12px;
	color: rgba(0, 0, 0, 0.45);
	margin-top: 4px;
}
.amount-up {
	color: #52c41a;
}

.amount-down {
	color: #ff4d4f;
}
</style>
